<template>
  <div class="block" style="margin-bottom: -6px">
    <video
      src="../assets/videos/hands.mp4"
      autoplay
      loop
      muted
      defaultMuted
      playsinline
    ></video>

    <div class="container position-absolute top-50 start-50 translate-middle">
      <h1 v-if="viewStore.isMobile" class="text-center header-title pb-5 fs-6">
        Full Service
      </h1>
      <h1 v-else class="text-center header-title pb-5">Full Service</h1>
      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 pb-5">
        <!-- Loop -->
        <div v-for="(skill, index) in skills" :key="index" class="col pb-4">
          <div
            class="card"
            style="min-height: 250px"
            @mouseenter="openSkill(index)"
            @mouseleave="closeSkill(index)"
          >
            <div class="card-body">
              <div
                v-if="showSkill !== index"
                class="d-flex h-100 justify-content-center"
              >
                <h3 class="card-title-closed align-self-center text-center p-2">
                  {{ skill.header }}
                </h3>
              </div>

              <div v-else class="open-card">
                <h5 class="card-title">{{ skill.header }}</h5>
                <p class="card-text fs-5">
                  {{ skill.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useViewStore } from "../stores/ViewStore";

const viewStore = useViewStore();

const showSkill = ref(null);

const openSkill = (index) => {
  showSkill.value = index;
};
const closeSkill = () => {
  showSkill.value = null;
};

const skills = ref([
  {
    header: "Lektorat",
    description:
      "Wir bieten eine professionelle Unterstützung sowie Beratung  bei der Rechtschreibung, Stilistik oder Grammatik.",
  },
  {
    header: "Sprecher & Sprecherin",
    description:
      "Unser Voice Pool bietet für jedes Hörbuch die passende Stimme. Ob Profi, Newcomer oder dein:e Lieblingssprecher:in. Wir machen es möglich!",
  },
  {
    header: "Übersetzung & Aussprache",
    description:
      "Neben dem Lektorat arbeiten wir mit professionellen Coaches, die dir zur bestmöglichen Aussprache und Intonation verhelfen.",
  },
  {
    header: "Sounddesign & Musik",
    description:
      "Wir schaffen Atmosphäre! Musik transportiert  Emotionen bei der Zuhörerschaft. Wir bieten erstklassige Musikauswahl und passendes Sound Design für ein noch intensiveres Hörerlebnis.",
  },
  {
    header: "Distribution & Vermarktung",
    description:
      "Durch unser breites Netzwerk an digitalen Distributoren können wir im Digitalvertrieb jedes Hörbuch vermarkten lassen und sorgen dafür, dass du gehört wirst.",
  },
  {
    header: "Cover Design",
    description:
      "Unsere Produkte sollen sich nicht nur hören, sondern auch sehen lassen können: Deshalb produzieren wir neben Audios auch ihre Cover Designs: Deine eigene Cover-Version für dein Original.",
  },
]);
</script>

<style scoped>
.header-title {
  color: #fc4667;
  font-weight: 900;
  font-size: 3.5rem;
}
.block {
  position: relative;
  /* bottom: 0; */
  width: 100%;
  height: 100%;
}

.card-title {
  color: black !important;
  font-weight: 700;
}

.card-title-closed {
  color: black !important;
  font-weight: 700;
}

open-card {
  transition: display 0.5s;
}

.card-body:hover {
  cursor: pointer;
  transition-duration: 0.5;
}

.card {
  height: 100%;
  border: none;
  background-color: rgba(255, 255, 255, 0.66);
}

.card:hover {
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-body-color-rgb), 0.15) !important;
  transition-duration: 0.5;
}

video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease-in;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
